import { DialogService } from 'app/shared/services/dialog-service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { StagesComponent } from 'app/stages/stages.component';
import { LoadingSpinnerService } from 'app/shared/services/loading-spinner.service';
import { CanDeactivate } from '@angular/router';

@Injectable()
export class CanDeactivateStage implements CanDeactivate<StagesComponent>{

    constructor(private loader: LoadingSpinnerService, private dialogSer: DialogService) {

    }
    canDeactivate(component: StagesComponent): Observable<boolean> | Promise<boolean> | boolean {
        if (component.isCurrentStageUnsaved())
            return new Observable<boolean>(observer => {
                this.loader.hideSpinner();
                this.dialogSer.openConfirmDialog('Warning', 'Stage contains unsaved data. Are you sure you want to close it?', () => {
                    observer.next(true);
                    observer.complete();
                }, () => {
                    observer.next(false);
                    observer.complete();
                }); 

            });
        return true;
    }


}


// WEBPACK FOOTER //
// ./src/app/stages/can-deactivate-stage.ts